// extracted by mini-css-extract-plugin
export default {"reg":"RegContent_reg__57S6r","reg__btn":"RegContent_reg__btn__TcZlJ","reg__enter":"RegContent_reg__enter__x8Upm"};